/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Route, Routes } from "react-router";
import LpOnlineDivorce from "../../containers/Pages/Divorce/LandingPagesDivorce/LpOnlineDivorce/LpOnlineDivorce";
import LpDivorcePetition from "../../containers/Pages/Divorce/LandingPagesDivorce/LpDivorcePetition/LpDivorcePetition";
import LpLinksOverviewPage from "../../containers/Pages/Generic/LpLinksOverviewPage/LpLinksOverviewPage";
import LpDivorceAgreement from "../../containers/Pages/Divorce/LandingPagesDivorce/LpDivorceAgreement/LpDivorceAgreement";
import LpCalculateSettlement from "../../containers/Pages/Settlement/LandingsPagesSettlement/LpCalculateSettlement/LpCalculateSettlement";
import LpModules from "../../containers/Pages/Divorce/LandingPagesDivorce/LpModules/LpModules";
import LpDivorce from "../../containers/Pages/Divorce/LandingPagesDivorce/LpDivorce/LpDivorce";
import LpFineDrivingBan from "../../containers/Pages/Traffic/LandingPagesTraffic/LpFineDrivingBan/LpFineDrivingBan";
import LpRedLight from "../../containers/Pages/Traffic/LandingPagesTraffic/LpRedLight/LpRedLight";
import LpSpeeding from "../../containers/Pages/Traffic/LandingPagesTraffic/LpSpeeding/LpSpeeding";
import LpTrafficOther from "../../containers/Pages/Traffic/LandingPagesTraffic/LpTrafficOther/LpTrafficOther";
import LpDistance from "../../containers/Pages/Traffic/LandingPagesTraffic/LpDistance/LpDistance";
import LpDismissal from "../../containers/Pages/Settlement/LandingsPagesSettlement/LpDismissal/LpDismissal";
import LpContractAdvocard from "../../containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpContractAdvocard";
import DismissalCheckAragPage from "../../containers/Pages/Settlement/LandingsPagesSettlement/LpDismissalArag/DismissalCheckAragPage";
import LpFineDrivingBanPartner from "../../containers/Pages/Traffic/LandingPagesTraffic/LpFineDrivingBanPartner/LpFineDrivingBanPartner";
import LpAlimonyPartner from "../../containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpAlimonyPartner";
import LpFamilyLawPartner from "../../containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpFamilyLawPartner";
import LpDivorcePartner from "../../containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpDivorcePartner";
import LpDeathPartner from "../../containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpDeathPartner";
import LpFamilyLawConsultingPartner from "../../containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpFamilyLawConsultingPartner";
import useTracker from "../../services/useTracker";
import HomePage from "../../containers/Pages/Generic/HomePage/HomePage";
import LpExternalLawyer from "../../containers/Pages/LpExternalLawyer/LpExternalLawyer";
import LpSpecialEnergyCasesAdvocard from "../../containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpSpecialEnergyCasesAdvocard";
import DismissalCheckWbsPage from "../../containers/Pages/Settlement/LandingsPagesSettlement/LpDismissalWbs/DismissalCheckWbsPage";
import SchufaWbsPage from "../../containers/Pages/ContractLaw/LandingPagesContractLaw/Wbs/SchufaWbsPage";
import LpTenancyLawAdvocard from "../../containers/Pages/TenancyLaw/LpTenancyLawAdvocard";
import LpAdvocardFlex from "../../containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpAdvocardFlex";
import { Navigate } from "react-router";
import LpCivilLawAdvocard from "../../containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpCivilLawAdvocard";
import LpEmploymentLawAdvocard from "../../containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpEmploymentLawAdvocard";
import LpTrafficAccident from "../../containers/Pages/TrafficLaw/LandingPagesTrafficLaw/LpTrafficAccident/LpTrafficAccident";
import { PARTNER_IRIS } from "../../constants/partnerIris";

export default function LandingPage() {
  useTracker({ withGclid: true });

  return (
    <Routes>
      <Route path={`links-overview`} element={<LpLinksOverviewPage />} />
      <Route path={`internet-scheidung`} element={<LpOnlineDivorce />} />
      <Route path={`online-scheidung`} element={<LpOnlineDivorce />} />
      <Route path={`scheidungsfolgenvereinbarung`} element={<LpDivorceAgreement />} />
      <Route path={`scheidungsantrag`} element={<LpDivorcePetition />} />
      <Route path={`scheidung`} element={<LpDivorce />} />
      <Route path={`kuendigung`} element={<LpDismissal />} />
      <Route path={`abfindung`} element={<LpCalculateSettlement />} />
      <Route path={`bussgeld-fahrverbot`} element={<LpFineDrivingBan />} />
      <Route path={`rote-ampel`} element={<LpRedLight />} />
      <Route path={`verkehrsunfall`} element={<LpTrafficAccident />} />
      <Route path={`abstandsverstoss`} element={<LpDistance />} />
      <Route path={`geschwindigkeit`} element={<LpSpeeding />} />
      <Route path={`verkehr-sonstiges`} element={<LpTrafficOther />} />
      <Route path={`modules`} element={<LpModules />} />

      <Route path={`advocard/bussgeld-fahrverbot`} element={<LpFineDrivingBanPartner partnerIri={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/unterhalt`} element={<LpAlimonyPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/familienrecht`} element={<LpFamilyLawPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/scheidung`} element={<LpDivorcePartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/todesfall`} element={<LpDeathPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/vertragsrecht`} element={<LpContractAdvocard />} />
      <Route path={`advocard/arbeitsrecht`} element={<LpEmploymentLawAdvocard />} />
      <Route path={`advocard/zivilrecht`} element={<LpCivilLawAdvocard />} />
      <Route path={`advocard/energie-hilfe`} element={<LpSpecialEnergyCasesAdvocard />} />
      <Route path={`advocard/mietrecht`} element={<LpTenancyLawAdvocard />} />
      <Route path={`advocard/flexservice`} element={<LpAdvocardFlex />} />

      <Route path={`arag/bussgeld-fahrverbot`} element={<LpFineDrivingBanPartner partnerIri={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/unterhalt`} element={<LpAlimonyPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/familienrecht`} element={<LpFamilyLawPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/scheidung`} element={<LpDivorcePartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/todesfall`} element={<LpDeathPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/kuendigung`} element={<DismissalCheckAragPage />} />

      <Route path={`wbs/bussgeld-fahrverbot`} element={<LpFineDrivingBanPartner partnerIri={PARTNER_IRIS.WBS} />} />
      <Route path={`wbs/kuendigung`} element={<DismissalCheckWbsPage />} />
      <Route path={`wbs/schufa`} element={<Navigate to={"/lp/wbs/datenweitergabe"} replace={true} />} />
      <Route path={`wbs/datenweitergabe`} element={<SchufaWbsPage />} />

      <Route path={`deurag/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.DEURAG} />} />

      <Route path={`partneranwalt-werden`} element={<LpExternalLawyer />} />
      <Route path={"*"} element={<HomePage />} />
    </Routes>
  );
}
